import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-modal w-maxC" }
const _hoisted_2 = { class: "row w-full" }
const _hoisted_3 = { class: "contactInputGrid mtop-15" }
const _hoisted_4 = { class: "phone-form-item" }
const _hoisted_5 = { class: "main-m font-m" }
const _hoisted_6 = { class: "gcol-r mtop-035" }
const _hoisted_7 = { class: "phone-form-item" }
const _hoisted_8 = { class: "main-m" }
const _hoisted_9 = { class: "gcol-r mtop-035" }
const _hoisted_10 = { class: "phone-form-item" }
const _hoisted_11 = { class: "main-m" }
const _hoisted_12 = {
  style: {"grid-column":"right"},
  class: "row"
}
const _hoisted_13 = { class: "bg-modal w-maxC dropd-scroll" }
const _hoisted_14 = { class: "mtop-10 phone-form-item" }
const _hoisted_15 = { class: "main-m" }
const _hoisted_16 = { style: {"grid-column":"right"} }

import { ref, computed, type PropType, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useUiStore } from '@/stores/ui';
import gen from '@/functions/general.js';
import { getFlagEmojiForCountry, PHONE_PREFIX_LIST } from '@/functions/geo.js';
import { InstitutePhoneRequest, UpdatePhonePwrRequest } from '@/apiGenerate/medserver';
import ToggleSwitch from "primevue/toggleswitch";

type OwnerType = 'patient' | 'healthGroup' | 'institute'


export default /*@__PURE__*/_defineComponent({
  __name: 'phoneInput',
  props: {
  phone: {
    type: Object,
    required: false,
  },
  pwr: {
    type: Object,
    required: false,
  },
  iwr: {
    type: Object,
    required: false,
  },
  newIsMobile: {
    type: Boolean,
    required: false,
  },
  ownerType: {
    type: String as PropType<OwnerType>,
    required: true,
  },
  isUpdate: {
    type: Boolean,
    required: false,
    default: false
  }
},
  emits: ['close', 'update-person-phone', 'update-institute-phone', 'delete-person-phone', 'delete-institute-phone', 'create-person-phone', 'create-institute-phone'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();
const uiStore = useUiStore();

const props = __props;

const emits = __emit;

const focusRef = ref(null);
const dropd = ref<string>("");
const phoneIsMobile = ref<boolean>(props.phone?.isMobile || props.newIsMobile);
const isPreferredPhone = ref<boolean>(props.phone?.isPreferred);
const phoneNoteInput = ref<string>(props.phone?.note || '');

const isInstitute = computed(() => props.ownerType === 'institute');

const showPreferred = computed(() => {
  if (props.ownerType === 'patient') {
    return uiStore.adminDashBoardView === 'dashbPatient'
  }
  if (props.ownerType === 'institute') {
    return true
  }
  return false
})

const showNote = computed(() => !isInstitute.value)

async function updatePhone() {
  if (isInstitute.value && props.iwr) {
    const institutePhoneRequest: InstitutePhoneRequest = {
        isMobile: phoneIsMobile.value,
        number: phoneNumberInput.value,
        phonePrefix: currentPhonePrefix.value
    };

    emits('update-institute-phone', institutePhoneRequest);
  } else {
    const updatePhonePwrRequest: UpdatePhonePwrRequest = {
        phone: phoneNumberInput.value,
        prefixPhone: currentPhonePrefix.value,
        note: phoneNoteInput.value,
        isMobile: phoneIsMobile.value,
        isFavorite: isPreferredPhone.value
    };

    emits('update-person-phone', updatePhonePwrRequest);
  }
}

const phoneNumberInput = ref(props.phone?.phoneNumber || '');

const currentPhonePrefix = ref(props.phone?.phonePrefix || PHONE_PREFIX_LIST[0].prefix);

function setCountry(country) {
  currentPhonePrefix.value = country.prefix;
  dropd.value = "";
}

async function deletePhone() {
  if (!props.phone) return;
  
  if (isInstitute.value) {
    emits('delete-institute-phone');
  } else {
    emits('delete-person-phone');
  }

  emits('close');
}

async function addPhone() {
  if (props.phone) return;

  if (isInstitute.value) {
    emits('create-institute-phone', {phonePrefix: currentPhonePrefix.value, phoneNumber: phoneNumberInput.value, phoneIsMobile: phoneIsMobile.value});
  } else {
    emits('create-person-phone', {phonePrefix: currentPhonePrefix.value, phoneNumber: phoneNumberInput.value, phoneIsMobile: phoneIsMobile.value, phoneNote: phoneNoteInput.value});
  }

  emits('close');
}

const closeFormModal = () => {
  if (props.isUpdate) {
    updatePhone();
  } else {
    addPhone();
  }
}

onMounted(() => {
  focusRef.value.innerRef.focus()
})

return (_ctx: any,_cache: any) => {
  const _component_es_modal_header = _resolveComponent("es-modal-header")!
  const _component_text_item = _resolveComponent("text-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_inputBox = _resolveComponent("inputBox")!
  const _component_list_group = _resolveComponent("list-group")!
  const _component_dropdownBox = _resolveComponent("dropdownBox")!
  const _component_inputLineNew2 = _resolveComponent("inputLineNew2")!
  const _component_inputAreaAuto2 = _resolveComponent("inputAreaAuto2")!
  const _component_es_modal_footer = _resolveComponent("es-modal-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_es_modal_header, {
        header: _unref(t)('common.contactForm.title.phone'),
        "display-delete": !!props.phone,
        "label-delete": _unref(t)('action.delete'),
        "confirm-method": deletePhone
      }, null, 8, ["header", "display-delete", "label-delete"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (props.phone && showPreferred.value && !isInstitute.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('common.contactForm.label.phone.isDefault')), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(ToggleSwitch), {
                modelValue: isPreferredPhone.value,
                "onUpdate:modelValue": [
                  _cache[0] || (_cache[0] = ($event: any) => ((isPreferredPhone).value = $event)),
                  _cache[1] || (_cache[1] = ($event: any) => (isPreferredPhone.value = $event))
                ]
              }, null, 8, ["modelValue"])
            ])
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('settings.params.account.details.mobile')), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_unref(ToggleSwitch), {
          modelValue: phoneIsMobile.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((phoneIsMobile).value = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)('settings.params.account.details.phone')), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_dropdownBox, {
          modelValue: dropd.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dropd).value = $event)),
          openOn: "editPhonePrefix"
        }, {
          dropd: _withCtx(() => [
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PHONE_PREFIX_LIST), (country, index) => {
                return (_openBlock(), _createBlock(_component_list_group, {
                  key: index,
                  styles: "pad-s",
                  onClick: ($event: any) => (setCountry(country))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_text_item, {
                      txt: _unref(getFlagEmojiForCountry)(country.isoCode)
                    }, null, 8, ["txt"]),
                    _createVNode(_component_text_item, {
                      txt: '+' + country.prefix,
                      styles: "main-m",
                      class: "mleft-03 align-r",
                      style: {"width":"2rem"}
                    }, null, 8, ["txt"]),
                    _createVNode(_component_text_item, {
                      txt: country.term,
                      class: "mleft-08"
                    }, null, 8, ["txt"])
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_inputBox, null, {
              default: _withCtx(() => [
                _createVNode(_component_buttonGroup, null, {
                  default: _withCtx(() => [
                    (_unref(PHONE_PREFIX_LIST).find(item => item.prefix === currentPhonePrefix.value))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_text_item, {
                            txt: _unref(getFlagEmojiForCountry)(_unref(PHONE_PREFIX_LIST).find(item => item.prefix === currentPhonePrefix.value).isoCode)
                          }, null, 8, ["txt"]),
                          _createVNode(_component_text_item, {
                            txt: '+' + _unref(PHONE_PREFIX_LIST).find(item => item.prefix === currentPhonePrefix.value).prefix,
                            styles: "main-m",
                            class: "mleft-03"
                          }, null, 8, ["txt"])
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "mleft-06" }, null, -1)),
        _createVNode(_component_inputBox, null, {
          default: _withCtx(() => [
            _createVNode(_component_inputLineNew2, {
              ref_key: "focusRef",
              ref: focusRef,
              modelValue: phoneNumberInput.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((phoneNumberInput).value = $event)),
              onKeydown: _unref(gen).onlyInteger
            }, null, 8, ["modelValue", "onKeydown"])
          ]),
          _: 1
        })
      ]),
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "row w-full mtop-10" }, null, -1)),
      (showNote.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(t)('settings.params.account.details.note')), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_inputBox, null, {
                default: _withCtx(() => [
                  _createVNode(_component_inputAreaAuto2, {
                    modelValue: phoneNoteInput.value,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((phoneNoteInput).value = $event)),
                    lines: 3
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_es_modal_footer, {
      onModalCancel: _cache[6] || (_cache[6] = ($event: any) => (emits('close'))),
      "confirm-modal-method": closeFormModal,
      class: "mtop-12"
    })
  ]))
}
}

})